(function(){
  function start(){
    if (window.matchMedia('(hover: none)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!document.body) { setTimeout(start, 50); return; }
    if (document.getElementById('mb-cursor-halo')) return;

    var halo = document.createElement('div');
    halo.id = 'mb-cursor-halo';
    document.body.appendChild(halo);

    var mouseX = window.innerWidth / 2, mouseY = window.innerHeight / 2;
    var haloX = mouseX, haloY = mouseY;

    window.addEventListener('mousemove', function(e){
      mouseX = e.clientX;
      mouseY = e.clientY;
      halo.style.opacity = '1';
    }, { passive: true });

    document.addEventListener('mouseleave', function(){
      halo.style.opacity = '0';
    });

    function loop(){
      haloX += (mouseX - haloX) * 0.15;
      haloY += (mouseY - haloY) * 0.15;
      halo.style.transform = 'translate(' + haloX + 'px,' + haloY + 'px)';
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);
  }
  start();
})();